import type { ReactNode } from "react";
import type { StudioPaneSkeletonVariant } from "./studio-pane-skeleton-types";
import { PaneVariantBody, ShellHeadStub, ShellMobileNavStub } from "./studio-pane-skeleton-parts";
import "./studio-pane-skeleton.css";

/** First-paint boot frame: real shell classes, server-rendered. */
export function StudioPaneSkeletonBootShell({
  variant = "boot-messages",
  main,
  tab,
}: {
  variant?: StudioPaneSkeletonVariant;
  main?: ReactNode;
  /** Title of the one active tab in the strip (default landing). */
  tab?: string;
}) {
  return (
    <div className="studio-stage studio-pane-skeleton-root" aria-hidden="true">
      <ShellHeadStub tab={tab} />
      <div className="studio-polish is-studio-mobile studio-mobile-stage">
        <div className="studio-pane-skeleton-embedded" role="status" aria-label="Loading">
          <PaneVariantBody variant={variant} main={main} isMobile />
        </div>
      </div>
      <ShellMobileNavStub />
    </div>
  );
}
